const r = (t) => t.tagName === "SELECT" && !t.disabled || !!t.name && !t.disabled && t.type !== "file" && t.type !== "reset" && t.type !== "submit" && t.type !== "button", n = (t) => t == null ? "" : String(t), o = (t) => {
  if (t !== void 0)
    return n(t);
}, i = (t) => ({
  target: { value: t }
});
export {
  n as getFormControlValueAsString,
  o as getFormControlValueAsStringIfDefined,
  i as getValueAsEvent,
  r as isValidFormInputElement
};
